<div class="action-wrapper" (click)="$event.stopPropagation()">
  <button mat-button class="action-trigger" [matMenuTriggerFor]="actionMenu">
  {{ 'action' | titlecase }}
  </button>

  <mat-menu #actionMenu="matMenu" xPosition="after" yPosition="below">
    <button mat-menu-item (click)="onViewDetails()">View Details</button>
    <button mat-menu-item (click)="onViewApplication()">
      View Application
    </button>

    <button mat-menu-item (click)="onRenew()" [disabled]="!row?.canRenew">
      Renew
    </button>

    <button mat-menu-item (click)="onDelete()" [disabled]="row?.isDeleted">Delete</button>

    <button mat-menu-item (click)="onDisable()" [disabled]="row?.isDisabled">
      Disable
    </button>

    <button mat-menu-item (click)="onEnable()" [disabled]="!row?.isDisabled">
      Enable
    </button>
  </mat-menu>
</div>
